<h2>Grid</h2>
<p class="demo-description">Demonstrates <code>upp-grid</code> with items, empty state, and GRID/LIST toggle.</p>

<!-- Controls -->
<div class="demo-controls">
    <ion-button size="small" (click)="toggleViewMode()">Mode: {{ viewMode }}</ion-button>
    <ion-button size="small" (click)="toggleGridSize()">Size: {{ gridSize }}</ion-button>
    <ion-button size="small" (click)="toggleItems()">{{ showItems ? 'Clear Items' : 'Show Items' }}</ion-button>
</div>

<!-- upp-grid demo -->
<div class="demo-section">
    <h3>upp-grid (name=DEMO_GRID, size={{ gridSize }})</h3>
    <div style="min-height: 300px; border: 1px solid var(--ion-color-medium, #ccc); border-radius: 8px; padding: 8px;">
        <upp-grid name="DEMO_GRID" [size]="gridSize">
            <upp-grid-empty>
                <div style="text-align: center; padding: 48px 16px; color: var(--ion-color-medium);">
                    <ion-icon name="grid-outline" style="font-size: 48px;"></ion-icon>
                    <p>No items to display</p>
                </div>
            </upp-grid-empty>

            <ng-container *ngIf="showItems">
                <upp-grid-item *ngFor="let item of items">
                    <upp-thumb
                        [title]="item.title"
                        [color]="item.color"
                        [icon]="item.icon">
                        <upp-thumb-bottom>
                            <ion-label>{{ item.title }}</ion-label>
                        </upp-thumb-bottom>
                    </upp-thumb>
                </upp-grid-item>
            </ng-container>
        </upp-grid>
    </div>
</div>
